// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-recommendation-request-card {
  margin-bottom: 1rem;
  padding: 0;
  box-shadow: 0 2px 2px 0 var(--main-gray);
  border-radius: var(--main-border-radius);
  transition: box-shadow 600ms;
  background-color: var(--main-bg-color-lighter);
}
.lsn-recommendation-request-card .lsn-deleted-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: color-mix(in srgb, var(--main-bg-color-lighter), transparent);
  z-index: 1;
}
.lsn-recommendation-request-card .lsn-deleted-cover::after {
  content: attr(title);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.4rem;
  color: var(--main-dark-gray);
  text-align: center;
  font-weight: bolder;
  text-transform: uppercase;
}
.lsn-recommendation-request-card.lsn-request-card:hover {
  box-shadow: 0 0 10px 0px var(--main-gray);
}
.lsn-recommendation-request-card.lsn-request-card-requested {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-requested) 60%, transparent);
}
.lsn-recommendation-request-card.lsn-request-card-requested:hover {
  border-left-color: var(--main-eval-requested);
  box-shadow: 0 0 10px 0px var(--main-eval-requested);
}
.lsn-recommendation-request-card.lsn-request-card-accepted {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-accepted) 60%, transparent);
}
.lsn-recommendation-request-card.lsn-request-card-accepted:hover {
  border-left-color: var(--main-eval-accepted);
  box-shadow: 0 0 10px 0px var(--main-eval-accepted);
}
.lsn-recommendation-request-card.lsn-request-card-completed {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-completed) 60%, transparent);
}
.lsn-recommendation-request-card.lsn-request-card-completed:hover {
  border-left-color: var(--main-eval-completed);
  box-shadow: 0 0 10px 0px var(--main-eval-completed);
}
.lsn-recommendation-request-card.lsn-request-card-declined {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-declined) 60%, transparent);
}
.lsn-recommendation-request-card.lsn-request-card-declined:hover {
  border-left-color: var(--main-eval-declined);
  box-shadow: 0 0 10px 0px var(--main-eval-declined);
}
.lsn-recommendation-request-card.lsn-request-card-expired {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-expired) 60%, transparent);
}
.lsn-recommendation-request-card.lsn-request-card-expired:hover {
  border-left-color: var(--main-eval-expired);
  box-shadow: 0 0 10px 0px var(--main-eval-expired);
}
.lsn-recommendation-request-card.lsn-request-card-deleted {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-deleted) 60%, transparent);
  position: relative;
  pointer-events: none;
}
.lsn-recommendation-request-card.lsn-request-card-deleted:hover {
  border-left-color: var(--main-eval-deleted);
  box-shadow: 0 0 10px 0px var(--main-eval-deleted);
}
.lsn-recommendation-request-card.lsn-request-card-deleted .panel-header,
.lsn-recommendation-request-card.lsn-request-card-deleted .lsn-panel-body {
  filter: grayscale();
  opacity: 0.5;
}
.lsn-recommendation-request-card .panel-header i.fa-chevron {
  display: inline-block;
  vertical-align: -1px;
  width: 1rem;
  text-align: center;
  color: var(--main-primary-color);
  cursor: pointer;
}
.lsn-recommendation-request-card .panel-title {
  display: flex;
  align-items: baseline;
  cursor: pointer;
  background: none;
  border: none;
  column-gap: 0.5rem;
  font-size: var(--main-font-size-primary);
  color: var(--main-text-color);
  flex-wrap: wrap;
  text-overflow: ellipsis;
}
.lsn-recommendation-request-card .delegation-prohibited {
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 1rem;
  align-items: center;
  border: var(--main-border-width) solid var(--main-orange);
  border-radius: var(--main-border-radius);
  padding: 0.5rem;
  background-color: color-mix(in srgb, var(--main-yellow) 10%, var(--main-white) 80%);
}
.lsn-recommendation-request-card .delegation-prohibited > i {
  color: var(--main-orange);
}
.lsn-recommendation-request-card .delegation-prohibited > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}
.lsn-recommendation-request-card button.link {
  display: flex;
}
.lsn-recommendation-request-card .lsn-panel-body {
  padding: 0.1rem 0.5rem;
  border-top: var(--main-border-width) solid var(--main-border-color);
}
.lsn-recommendation-request-card .lsn-recommendation-list-items {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.5rem;
}
.lsn-recommendation-request-card .lsn-recommendation-list-items ul {
  margin: 0;
}
.lsn-recommendation-request-card .lsn-recommendation-list-items span,
.lsn-recommendation-request-card .lsn-recommendation-list-items a {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.lsn-recommendation-request-card .lsn-recommendation-list-items .list li {
  display: grid;
  gap: 0.3rem;
  grid-template-columns: max-content minmax(0, 1fr);
}
.lsn-recommendation-request-card .lsn-recommendation-header {
  padding: 0.2rem 0.5rem;
  display: grid;
  align-items: center;
  gap: 0.4rem;
  grid-template-columns: max-content 1fr;
  border-top-left-radius: 10px;
  line-height: normal;
}
.lsn-recommendation-request-card .lsn-recommendation-header .evaluation-controls {
  display: flex;
  align-items: flex-end;
  justify-content: end;
  column-gap: 0.5rem;
  grid-column: 1 / span 2;
  flex-wrap: wrap;
  row-gap: 0.5rem;
}
.lsn-recommendation-request-card .lsn-collapse {
  display: none;
  transition: transform 0.3s ease-in-out;
}
.lsn-recommendation-request-card .lsn-expand {
  display: block;
  transition: transform 0.3s ease-in-out;
}
@media (min-width: 990px) {
  .lsn-recommendation-request-card .lsn-recommendation-header {
    grid-template-rows: 1fr;
    grid-template-columns: auto 1fr max-content;
  }
  .lsn-recommendation-request-card .lsn-recommendation-header > a {
    grid-template-columns: max-content minmax(0, max-content) max-content max-content max-content;
    gap: 0.5rem;
  }
  .lsn-recommendation-request-card .lsn-recommendation-header .evaluation-controls {
    grid-column: auto;
  }
  .lsn-recommendation-request-card .lsn-recommendation-list-items {
    grid-template-columns: 1.5fr 1fr max-content;
  }
  .lsn-recommendation-request-card .lsn-recommendation-list-items .list:last-child {
    text-align: right;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/RequestCard/RequestCard.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,UAAA;EACA,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,8CAAA;AACF;AAPA;EASI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+EAAA;EACA,UAAA;AACJ;AACI;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AACN;AAII;EACE,yCAAA;AAFN;AAcI;EARE,sFAAA;AAHN;AAKM;EACE,6CAAA;EACA,mDAAA;AAHR;AAWI;EAZE,qFAAA;AAIN;AAFM;EACE,4CAAA;EACA,kDAAA;AAIR;AAQI;EAhBE,sFAAA;AAWN;AATM;EACE,6CAAA;EACA,mDAAA;AAWR;AAKI;EApBE,qFAAA;AAkBN;AAhBM;EACE,4CAAA;EACA,kDAAA;AAkBR;AAEI;EAxBE,oFAAA;AAyBN;AAvBM;EACE,2CAAA;EACA,iDAAA;AAyBR;AADI;EA5BE,oFAAA;EA8BA,kBAAA;EACA,oBAAA;AAGN;AAhCM;EACE,2CAAA;EACA,iDAAA;AAkCR;AAVI;;EAOI,mBAAA;EACA,YAAA;AAOR;AAhFA;EAgFM,qBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AAGN;AAxFA;EA0FI,aAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,6BAAA;EACA,eAAA;EACA,uBAAA;AACJ;AApGA;EAuGI,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;EAEA,yDAAA;EACA,wCAAA;EACA,eAAA;EACA,mFAAA;AADJ;AA9GA;EAkHM,yBAAA;AADN;AAjHA;EAsHM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AAFN;AAvHA;EA8HI,aAAA;AAJJ;AA1HA;EAkII,sBAAA;EACA,mEAAA;AALJ;AA9HA;EAuII,aAAA;EACA,qCAAA;EACA,WAAA;AANJ;AAnIA;EA4IM,SAAA;AANN;AAtIA;;EAiJM,mBAAA;EACA,uBAAA;EACA,gBAAA;AAPN;AA5IA;EAwJQ,aAAA;EACA,WAAA;EACA,iDAAA;AATR;AAjJA;EAiKI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AAbJ;AA1JA;EA0KM,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AAbN;AAnKA;EAqLI,aAAA;EACA,sCAAA;AAfJ;AAvKA;EA0LI,cAAA;EACA,sCAAA;AAhBJ;AAmBE;EAAA;IAEI,uBAAA;IACA,2CAAA;EAjBJ;EAcA;IAMM,6FAAA;IACA,WAAA;EAjBN;EAUA;IAWM,iBAAA;EAlBN;EAOA;IAgBI,4CAAA;EApBJ;EAIA;IAmBM,iBAAA;EApBN;AACF","sourcesContent":[".lsn-recommendation-request-card {\n  margin-bottom: 1rem;\n  padding: 0;\n  box-shadow: 0 2px 2px 0 var(--main-gray);\n  border-radius: var(--main-border-radius);\n  transition: box-shadow 600ms;\n  background-color: var(--main-bg-color-lighter);\n\n  .lsn-deleted-cover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: color-mix(in srgb, var(--main-bg-color-lighter), transparent);\n    z-index: 1;\n\n    &::after {\n      content: attr(title);\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      font-size: 1.4rem;\n      color: var(--main-dark-gray);\n      text-align: center;\n      font-weight: bolder;\n      text-transform: uppercase;\n    }\n  }\n\n  &.lsn-request-card {\n    &:hover {\n      box-shadow: 0 0 10px 0px var(--main-gray);\n    }\n\n    ._mx_card_status(@status_color) {\n      border-left: 7px solid color-mix(in srgb, @status_color 60%, transparent);\n\n      &:hover {\n        border-left-color: @status_color;\n        box-shadow: 0 0 10px 0px @status_color;\n      }\n    }\n\n    &-requested {\n      ._mx_card_status(var(--main-eval-requested));\n    }\n\n    &-accepted {\n      ._mx_card_status(var(--main-eval-accepted));\n    }\n\n    &-completed {\n      ._mx_card_status(var(--main-eval-completed));\n    }\n\n    &-declined {\n      ._mx_card_status(var(--main-eval-declined));\n    }\n\n    &-expired {\n      ._mx_card_status(var(--main-eval-expired));\n    }\n\n    &-deleted {\n      ._mx_card_status(var(--main-eval-deleted));\n      position: relative;\n      pointer-events: none;\n\n      .panel-header,\n      .lsn-panel-body {\n        filter: grayscale();\n        opacity: .5;\n      }\n    }\n  }\n\n  .panel-header {\n    i.fa-chevron {\n      display: inline-block;\n      vertical-align: -1px;\n      width: 1rem;\n      text-align: center;\n      color: var(--main-primary-color);\n      cursor: pointer;\n    }\n  }\n\n  .panel-title {\n    display: flex;\n    align-items: baseline;\n    cursor: pointer;\n    background: none;\n    border: none;\n    column-gap: .5rem;\n    font-size: var(--main-font-size-primary);\n    color: var(--main-text-color);\n    flex-wrap: wrap;\n    text-overflow: ellipsis;\n  }\n\n  .delegation-prohibited {\n    display: grid;\n    grid-template-columns: min-content 1fr;\n    gap: 1rem;\n    align-items: center;\n\n    border: var(--main-border-width) solid var(--main-orange);\n    border-radius: var(--main-border-radius);\n    padding: .5rem;\n    background-color: color-mix(in srgb, var(--main-yellow) 10%, var(--main-white) 80%);\n\n    >i {\n      color: var(--main-orange)\n    }\n\n    >div {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: .5rem;\n    }\n  }\n\n  button.link {\n    display: flex;\n  }\n\n  .lsn-panel-body {\n    padding: .1rem .5rem;\n    border-top: var(--main-border-width) solid var(--main-border-color);\n  }\n\n  .lsn-recommendation-list-items {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: .5rem;\n\n    ul {\n      margin: 0;\n    }\n\n    span,\n    a {\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n\n    .list {\n      li {\n        display: grid;\n        gap: .3rem;\n        grid-template-columns: max-content minmax(0, 1fr);\n      }\n\n    }\n  }\n\n  .lsn-recommendation-header {\n    padding: .2rem .5rem;\n    display: grid;\n    align-items: center;\n    gap: .4rem;\n    grid-template-columns: max-content 1fr;\n    border-top-left-radius: 10px;\n    line-height: normal;\n\n    .evaluation-controls {\n      display: flex;\n      align-items: flex-end;\n      justify-content: end;\n      column-gap: .5rem;\n      grid-column: 1/ span 2;\n      flex-wrap: wrap;\n      row-gap: .5rem;\n    }\n  }\n\n  .lsn-collapse {\n    display: none;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .lsn-expand {\n    display: block;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  @media (min-width: 990px) {\n    .lsn-recommendation-header {\n      grid-template-rows: 1fr;\n      grid-template-columns: auto 1fr max-content;\n\n      >a {\n        grid-template-columns: max-content minmax(0, max-content) max-content max-content max-content;\n        gap: .5rem;\n      }\n\n      .evaluation-controls {\n        grid-column: auto;\n      }\n    }\n\n    .lsn-recommendation-list-items {\n      grid-template-columns: 1.5fr 1fr max-content;\n\n      .list:last-child {\n        text-align: right;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
